import type { ReactNode } from "react";
import { cx } from "@/lib/cx";

interface BannerProps {
  tone?: "info" | "warn" | "danger" | "ok";
  children: ReactNode;
  className?: string;
  role?: "alert" | "status";
}

export function Banner({ tone = "info", children, className, role }: BannerProps) {
  return (
    <div className={cx("banner", tone, className)} role={role ?? (tone === "danger" ? "alert" : "status")}>
      {children}
    </div>
  );
}
